import { render, staticRenderFns } from "./ConteudoCliente.vue?vue&type=template&id=4a87ff8b"
import script from "./ConteudoCliente.vue?vue&type=script&lang=js"
export * from "./ConteudoCliente.vue?vue&type=script&lang=js"
import style0 from "./ConteudoCliente.vue?vue&type=style&index=0&id=4a87ff8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports